export const textboxField = {
  required: false,
  fontSize: '20px',
  color_font: '#5e5873',
  width: '100%',
  readonly: false,
};

export const textAreaField = {
  required: false,
  fontSize: '20px',
  color_font: '#5e5873',
  width: '100%',
  row: 1,
  max_row: 3,
  readonly: false,
};

export const dropdownField = {
  required: false,
  fontSize: '20px',
  color_font: '#5e5873',
  readonly: false,
  clearable: true,
  width: '100%',
};

export const datePickerField = {
  required: false,
  fontSize: '20px',
  color_font: '#5e5873',
  readonly: false,
  width: '25%',
};

export const toggleField = {
  required: false,
  fontSize: '20px',
  color_font: '#5e5873',
};
